import { FC, useEffect, useState } from "react"
import './index.css'
import { usePluginspace } from "../../hooks/usePluginspace"

type StoreInfoHours = {
  hours:any
  config:any
}

const StoreInfoHours : FC<StoreInfoHours> = ({hours,config}) =>{
  const { getVerifyShift } = usePluginspace();
  const [open,setOpen] = useState(false)

  async  function isOpen(){
    const res = await getVerifyShift()
    setOpen(res)
  }

  useEffect(()=>{
    isOpen()
  },[])

  return (
    <div className="info-loja-funcionamento">
    <h4>Horários de funcionamento</h4>
    <div className="info-loja-funcionamento-status" style={{
        background:config?.webappcolor.backgroundstatusactive ? config?.webappcolor.backgroundstatusactive : '#67BF5F',
        color:config?.webappcolor.fontbutton ? config?.webappcolor.fontbutton : '#FFFFFF'
    }}>
    <span>Agora : {`${open ? 'Aberto' : 'Fechado' }`}</span>
    </div>
    <div className="info-loja-funcionamento-horas">
      {
        hours.map((hour : any) => (
          <div className="hour" key={hour.id}
            style={{
              color: new Date().getDay() === hour.weekday ?  config?.webappcolor.backgroundstatusactive : ''
            }}
          >
             <span className="dia-funcionamento">{hour.day}:</span>
             <span className="hora-funcionamento">{hour.hour}</span>
          </div>
        ))
      }

    </div>
  </div>
  )
}

export {StoreInfoHours}